import { TransitionNewModule } from './../transitions-new/transition-new.module';
import { SidenavModule } from "./../sidenav/sidenav.module";
import { TopnavModule } from "./../topnav/topnav.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LayoutComponent } from "./layout.component";


@NgModule({
	declarations: [LayoutComponent],
	imports: [
		CommonModule,
		TopnavModule,
		SidenavModule,
		TransitionNewModule
	],
	exports: [LayoutComponent]
})
export class LayoutModule { }
